import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import React, {useEffect, useState} from 'react';
import Title from 'Components/Atoms/Title/Title';
import Container from 'Components/Atoms/Container/Container';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import Button from 'Components/Atoms/Button/Button';
import {useMutation, useQuery} from 'react-query';
import {getAccessTokenFromLocal} from 'Services/helpers';
import {API_URL} from 'Store/Shared/Middleware/API/Constants';
import FormSection from 'Components/Molecules/Form/FormSection/FormSection';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import TextField from 'Components/Atoms/Fields/TextField/TextField';
import Tabs from 'Components/Molecules/Tabs/Tabs';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import {faPen, faPlus} from '@fortawesome/pro-solid-svg-icons';
import Options, {optionListStatusMap} from './Options';
import {useLocation} from 'react-router-dom';
import SelectField from 'Components/Molecules/Fields/SelectField/SelectField';

const OptionLists = ({ entity_record_id }: Props) => {
    const [newList, setNewList] = useState({
        candidate_id: entity_record_id,
        name: ''
    });
    const [editList, setEditList] = useState<any>({});
    const [state, setState] = useState({
        isChangeStatusModalOpen: false,
        isModalOpen: false,
        activeTab: '',
    });

    const location = useLocation();
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get('option_list_id')) {
            setState((state: any) => ({
                ...state,
                activeTab: queryParams.get('option_list_id')
            }));
        }
    }, [location]);

    const { isLoading, data, refetch } = useQuery(
        ['option-lists'],
        async () => {
            const seachParams = new URLSearchParams();
            seachParams.set('candidate_id', entity_record_id);

            const rawResponse = await fetch(`${API_URL}/api/v2.9/candidates/option_lists?${seachParams.toString()}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${getAccessTokenFromLocal()}`
                }
            });
            const response = await rawResponse.json();

            return response?.data;
        },
        {
            onSuccess: (data) => {
                setNewList((state) => ({
                    ...state,
                    name: `Lijst ${(data?.option_lists?.length ?? 0) + 1}`
                }));
                setState((state) => ({
                    ...state,
                    isModalOpen: false,
                    activeTab: state.activeTab === '' ? data?.option_lists?.[0]?.id : state.activeTab
                }));
            }
        }
    );
    const {
        mutateAsync: createOptionList,
        isLoading: isCreating
    } = useMutation(
        async (values: any) => {
            const rawResponse = await fetch(`${API_URL}/api/v2.9/candidates/option_lists`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${getAccessTokenFromLocal()}`
                },
                body: JSON.stringify(values)
            });
            const response = await rawResponse.json();

            return response?.data;
        },
        {
            onSuccess: () => refetch()
        }
    );
    const {
        mutateAsync: updateStatusList,
        isLoading: isUpdatingStatus
    } = useMutation(
        async ({id, status}: any) => {
            const rawResponse = await fetch(`${API_URL}/api/v2.9/candidates/option_lists/${id}`, {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${getAccessTokenFromLocal()}`
                },
                body: JSON.stringify({
                    status
                })
            });
            const response = await rawResponse.json();

            return response?.data;
        },
        {
            onSuccess: () => {
                const activeTab = state.activeTab;
                setState((state: any) => ({
                    ...state,
                    activeTab: null
                }));
                setTimeout(() => {
                    setState((state) => ({
                        ...state,
                        isChangeStatusModalOpen: false,
                        activeTab: activeTab
                    }));
                }, 100);
            }
        }
    );
    const {
        mutateAsync: deleteOptionList,
        isLoading: isDeleting
    } = useMutation(
        async (id: any) => {
            const rawResponse = await fetch(`${API_URL}/api/v2.9/candidates/option_lists/${id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${getAccessTokenFromLocal()}`
                }
            });

            return await rawResponse.json();
        }
    )

    const processStatusChange = async () => {
        await updateStatusList({
            id: state.activeTab,
            status: editList.status
        })
    }

    const handleChangeStatusClick = () => setState((state) => ({
        ...state,
        isChangeStatusModalOpen: !state.isChangeStatusModalOpen
    }));

    const handleModalClick = () => setState((state) => ({
        ...state,
        isModalOpen: !state.isModalOpen
    }));

    const handleTabClick = (key: string) => setState((state) => ({
        ...state,
        activeTab: key
    }));

    const handleCreateClick = async () => {
        const response = await createOptionList(newList);
        setState((state) => ({
            ...state,
            activeTab: response?.option_lists?.[0]?.id
        }));
    }

    const handleDeleteListClick = async (id: any) => {
        await deleteOptionList(id);
        refetch();
        setState((state) => ({
            ...state,
            activeTab: ''
        }));
    }

    return <>
        <div style={{
            width: '100%',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: 'column',
            gap: '16px'
        }}>
            {
                !isLoading &&
                <>
                    <Tabs
                        active={state.activeTab}
                        data={data?.option_lists?.map(i => ({
                            id: i.id,
                            title: i.name
                        }))}
                        onChange={handleTabClick}
                        onDelete={handleDeleteListClick}
                        isDeleting={isDeleting}
                        actions={
                            <ButtonGroup>
                                {
                                    state.activeTab &&
                                    <Button
                                        variant='tab'
                                        iconBefore={<FontAwesomeIcon icon={faPen} />}
                                        onClick={handleChangeStatusClick}
                                    >
                                        Alle opties status aanpassen
                                    </Button>
                                }
                                <Button
                                    variant='tab'
                                    iconBefore={<FontAwesomeIcon icon={faPlus} />}
                                    onClick={handleModalClick}
                                >
                                    Lijst toevoegen
                                </Button>
                            </ButtonGroup>
                        }
                    />
                </>
            }
            {
                state.activeTab &&
                <Options option_list_id={state.activeTab} />
            }
        </div>

        {
            state.isChangeStatusModalOpen &&
            <Modal>
                <ModalHeader>
                    <Title size="large">Verander alle status van de huidige optielijst</Title>
                </ModalHeader>
                <Container>
                    <div style={{height: '32px'}}/>
                    <FormSection>
                        <FormGroup title="Status">
                            <SelectField
                                isEdit={true}
                                value={editList?.status}
                                onChange={(value) => setEditList((editList) => ({
                                    ...editList,
                                    status: value
                                }))}
                                fieldProperties={{
                                    list: Object.keys(optionListStatusMap).map((item: any) => ({
                                        label: optionListStatusMap[item],
                                        value: item
                                    }))
                                }}
                            />
                        </FormGroup>
                    </FormSection>
                </Container>
                <ModalFooter>
                    <ButtonGroup>
                        <Button onClick={handleChangeStatusClick}>
                            Annuleren
                        </Button>
                        <Button
                            color="primary"
                            variant="solid"
                            onClick={processStatusChange}
                            isDisabled={isUpdatingStatus}
                            isLoading={isUpdatingStatus}
                        >
                            Aanpassen
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        }
        {
            state.isModalOpen &&
            <Modal>
                <ModalHeader>
                    <Title size="large">Voeg een nieuw optielijst toe</Title>
                </ModalHeader>
                <Container>
                    <div style={{height: '32px'}}/>
                    <FormSection>
                        <FormGroup title="Naam">
                            <TextField
                                placeholder="Naam"
                                value={newList.name}
                                onChange={(value) => setNewList({
                                    ...newList,
                                    name: value
                                })}
                            />
                        </FormGroup>
                    </FormSection>
                </Container>
                <ModalFooter>
                    <ButtonGroup>
                        <Button onClick={handleModalClick}>
                            Annuleren
                        </Button>
                        <Button
                            color="primary"
                            variant="solid"
                            onClick={handleCreateClick}
                            isDisabled={isCreating}
                            isLoading={isCreating}
                        >
                            Aanmaken
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        }
    </>;
}

interface Props {
    entity_record_id: string
};

export default OptionLists;